import React from "react";

const SvgMarketing = props => (
  <svg data-name="Layer 1" viewBox="0 0 215 215" {...props}>
    <path
      d="M213.92 34.65H1.08v125.87h6L2 168.39h8.87l7.87-7.87h21.5v-3H4.08V37.65h206.84v119.87H103.49v3h92.82l7.87 7.87h8.88l-5.14-7.87h6z"
      fill="currentColor"
    />
    <path
      d="M92.76 57.76H50.92a10.75 10.75 0 00-10.73 10.73v101.14a10.74 10.74 0 0010.73 10.72h41.84a10.74 10.74 0 0010.73-10.72V68.49a10.74 10.74 0 00-10.73-10.73zm7.73 111.87a7.73 7.73 0 01-7.73 7.72H50.92a7.73 7.73 0 01-7.73-7.72V68.49a7.74 7.74 0 017.73-7.73h41.84a7.74 7.74 0 017.73 7.73z"
      fill="currentColor"
    />
    <path
      d="M9.55 43.86v107.77h33.64V68.49a7.74 7.74 0 017.73-7.73h41.84a7.74 7.74 0 017.73 7.73v83.14h105.17V43.86z"
      fill="currentColor"
    />
    <path
      d="M96.43 68.49v101.14a3.67 3.67 0 01-3.67 3.67H50.92a3.67 3.67 0 01-3.67-3.67V68.49a3.67 3.67 0 013.67-3.67h6.64v2.43A3.73 3.73 0 0061.28 71H82.4a3.73 3.73 0 003.72-3.72v-2.46h6.64a3.67 3.67 0 013.67 3.67z"
      fill="currentColor"
    />
    <rect
      x={60.73}
      y={64.81}
      width={22.21}
      height={2.85}
      rx={1.42}
      fill="currentColor"
    />
  </svg>
);

export default SvgMarketing;